import React, { Component, Suspense, lazy } from "react";
import classes from "./AppBoot.scss";

/**
 * Boots the lazily-loaded app: shows `fallback` via Suspense while it downloads.
 * If the app fails to load, shows an error screen with a Reload button.
 *
 * Props: `loadApp` — dynamic-import thunk, e.g. () => import("./main");
 *        `fallback` — element shown while the app loads.
 */
class AppBoot extends Component {
  state = {
    hasError: false,
    App: lazy(this.props.loadApp),
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("App failed to boot:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { hasError, App } = this.state;
    if (hasError) {
      return (
        <div className={classes.errorScreen}>
          <div>{"Couldn't load Toddle. Please reload the page."}</div>
          <button
            type="button"
            data-test-id="boot-error-reload-button"
            className={classes.reloadButton}
            onClick={this.handleReload}
          >
            Reload
          </button>
        </div>
      );
    }
    return (
      <Suspense fallback={this.props.fallback}>
        <App />
      </Suspense>
    );
  }
}

export default AppBoot;
